import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Router } from '@angular/router';
import { SnackBarComponent } from '@components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material';
import { AccountService } from '@services/account.service';
import { catchError, tap } from 'rxjs/operators';
import { ImportTypeEnum } from '@models/importType.enum';

@Injectable()
export class ImportService {
  private fileTypes: any[] = ['csv', 'json', 'xml'];

  constructor(
    public matSnackBar: MatSnackBar,
    public accountService: AccountService,
    public router: Router
  ) {
  }

  public importFile(file: File, type, importTypeEnum: ImportTypeEnum, updateRecords: boolean): void {
    const extension = file.name.split('.').pop().toLowerCase();
    const rightType = this.fileTypes.indexOf(extension) > -1;
    if (rightType) {
      const myReader: FileReader = new FileReader();
      myReader.readAsDataURL(file);
      myReader.onloadend = () => {
        const encodedFile = myReader.result.split(',')[1];
        this.getMethod(importTypeEnum, encodedFile, type, extension, updateRecords)
          .pipe(
            catchError(() => {
              this.snackBar('Filen innehåller fel.');
              return of();
            })
          )
          .subscribe((response) => {
            this.snackBar('Importerade ' + response.count + ' adresser.', false);
            switch (importTypeEnum) {
              case ImportTypeEnum.ADDRESS_BOOK:
                return this.router.navigate(['address-book']);
              case ImportTypeEnum.SHIPMENT:
                return this.router.navigate(['shipments', 'saved']);
            }
          });
      };
    } else {
      this.snackBar('Fel fil-format');
    }
  }

  private snackBar(text: string, isError: boolean = true): void {
    this.matSnackBar.openFromComponent(SnackBarComponent, {
      data: {
        error: isError,
        message: text
      },
      panelClass: 'snackbar-container',
      duration: 3000,
    });
  }

  private getMethod(importTypeEnum: ImportTypeEnum, encodedFile: string, type: string, extension: string, updateRecords: boolean): Observable<any> {
    switch (importTypeEnum) {
      case ImportTypeEnum.ADDRESS_BOOK:
        return this.accountService.importAddressFile(encodedFile, type, extension, updateRecords);
      case ImportTypeEnum.SHIPMENT:
        return this.accountService.importShipmentFile(encodedFile, extension);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/import.service.ts